import _ from 'underscore';

export const getErrorString = (err) => {
  if (!err) {
    return '';
  }

  if (_.isString(err)) {
    return err;
  }

  if (_.isObject(err)) {
    const { name, message, stack } = err;
    if (message || stack) {
      return `Error: ${name}, message: ${message}, stack: ${stack}`;
    }
  }

  return JSON.stringify(err);
};
